var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:{'spinner--loading': _vm.loading}},[(_vm.showLoading)?_c('div',{staticClass:"spinner__loader"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }